import * as types from "../businessTrustpassActionTypes";

export default function businessTrustpass(state = {}, action) {
  switch (action.type) {
    case types.RECEIVE_BUSINESS_TRUSTPASS:
      return {
        ...state,
        ...action.payload,
      };
    case 'BUSINESS_TRUSTPASS_HYDRATE':
      return {...state, ...action.payload};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/trustpass/reducers/businessTrustpassReducer.js